var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code_wrap",attrs:{"id":"code"},on:{"click":function($event){return _vm.drawCode('')}}},[_c('canvas',{attrs:{"width":"100","height":"40","id":"verifyCanvas"}}),_c('img',{attrs:{"id":"code_img"}})])}
var staticRenderFns = []

export { render, staticRenderFns }